import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ChangeDetectionStrategy, ElementRef, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { NbTagComponent, NbTagInputDirective } from '@nebular/theme';
import { Observable, of } from 'rxjs';

@Component({
  selector: 'tag-access-point',
  templateUrl: './tag-acess-point.component.html',
  styleUrls: ['./tag-acess-point.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TagAcessPointComponent implements OnInit {

  @ViewChild(NbTagInputDirective, { read: ElementRef }) tagInput: ElementRef<HTMLInputElement>;
  @Input() set evaluatedTags(value: string[]) {
    this.tags = new Set(value);
  }
  @Input() set options(value: string[]) {
    this.optionFields = value;
    this.filteredOptions$ = of(value);
  }
  filteredOptions$: Observable<string[]>;
  @Output() tagAdded: EventEmitter<any> = new EventEmitter();
  @Output() tagRemoved: EventEmitter<any> = new EventEmitter();

  tags: Set<string> = new Set<string>();
  inputText: string = '';
  optionFields: string[] = []; 

  constructor() { }

  ngOnInit(): void {
  }

  filter(inputFilter) {
    this.filteredOptions$ = of(this.getFilteredOptions(inputFilter, this.optionFields));
  }

  onTagRemove(tagToRemove: NbTagComponent): void {
    this.tagRemoved.emit(tagToRemove.text);
    this.tags.delete(tagToRemove.text);
    this.optionFields.push(tagToRemove.text);
  }

  onTagAdd(input: string): void {
    if (!this.isNullOrEmpty(input)) {
      let optionMatched = this.optionFields.find(opt => opt.toLocaleLowerCase() == input.toLocaleLowerCase())
      if (!this.isNullOrEmpty(optionMatched)) {
        this.tagAdded.emit(optionMatched);
        this.tags.add(optionMatched);
        this.tagInput.nativeElement.value = '';
        this.optionFields.splice(this.optionFields.indexOf(optionMatched), 1);
      }
    }
  }

  getFilteredOptions(inputFilter: string, options: string[],
    errorForUnmatchedValues?: FormControl, emptyIsValid: boolean = false): string[] {
    if (options.some(optionValue => optionValue == inputFilter)
    || (emptyIsValid && this.isNullOrEmpty(inputFilter))) {
      if (errorForUnmatchedValues != undefined) errorForUnmatchedValues.setErrors(null);
      return options;
    }
    let matchValues = this.isNullOrEmpty(inputFilter) ? options
      : options.filter(optionValue => optionValue.toLowerCase().includes(inputFilter.toLowerCase()));
    if (errorForUnmatchedValues != undefined) errorForUnmatchedValues.setErrors({'incorrect': true});
    return matchValues;
  }

  isNullOrEmpty(value: string) {
    return value == null || value.trim() == '';
  }
}
